import Model from '@ember-data/model';
import attr from 'ember-data/attr';

export default class FacebookLeadAdsCredential extends Model {
  @attr('number') createdAt!: number;
  @attr('number') updatedAt!: number;

  @attr('string') pageId!: string;
  @attr('string') pageName!: string;

  @attr('string') userAccessToken!: string; // set only on creation (POST request), used by the back-end during setup: but not persisted
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'facebook-lead-ads-credential': FacebookLeadAdsCredential;
  }
}
